<div class="tabs-container">
    <tabs (tabClicked)="onTabClicked($event)">
        <tab title="Open">
            <ag-grid-angular class="data-grid " [gridOptions]="openGridOptions" [rowData]="openData | async" [attr.aria-label]="widgetTitle + ' - Open'"></ag-grid-angular>
        </tab>
        <tab title="Closed">
            <ag-grid-angular class="data-grid " [gridOptions]="closedGridOptions" [rowData]="closedData | async" [attr.aria-label]="widgetTitle + ' - Closed'"></ag-grid-angular>
        </tab>
    </tabs>
</div>
